/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelVoucherCittadinoDTO } from '../model/paged-model-voucher-cittadino-dto';
// @ts-ignore
import { PagedModelVoucherEsercenteDTO } from '../model/paged-model-voucher-esercente-dto';
// @ts-ignore
import { VoucherCittadinoDTO } from '../model/voucher-cittadino-dto';
// @ts-ignore
import { VoucherCittadinoListFilter } from '../model/voucher-cittadino-list-filter';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    CittadinoVoucherControllerServiceInterface,
    DettaglioMioVoucherRequestParams,
    DownloadMioVoucherPdfRequestParams,
    ElencoEsercentiMioVoucherRequestParams,
    ListaMieiVoucherRequestParams
} from './cittadino-voucher-controller.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class CittadinoVoucherControllerService extends BaseService implements CittadinoVoucherControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Dettaglio di un proprio voucher (owner-check; 404 se non del caller)
     * @endpoint get /api/v1/cittadino/voucher/{idVoucher}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public dettaglioMioVoucher(requestParameters: DettaglioMioVoucherRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VoucherCittadinoDTO>;
    public dettaglioMioVoucher(requestParameters: DettaglioMioVoucherRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VoucherCittadinoDTO>>;
    public dettaglioMioVoucher(requestParameters: DettaglioMioVoucherRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VoucherCittadinoDTO>>;
    public dettaglioMioVoucher(requestParameters: DettaglioMioVoucherRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idVoucher = requestParameters?.idVoucher;
        if (idVoucher === null || idVoucher === undefined) {
            throw new Error('Required parameter idVoucher was null or undefined when calling dettaglioMioVoucher.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/voucher/${this.configuration.encodeParam({name: "idVoucher", value: idVoucher, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VoucherCittadinoDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Download del PDF+QR di un proprio voucher (owner-check; 404 se non del caller)
     * @endpoint get /api/v1/cittadino/voucher/{idVoucher}/pdf
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public downloadMioVoucherPdf(requestParameters: DownloadMioVoucherPdfRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public downloadMioVoucherPdf(requestParameters: DownloadMioVoucherPdfRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public downloadMioVoucherPdf(requestParameters: DownloadMioVoucherPdfRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public downloadMioVoucherPdf(requestParameters: DownloadMioVoucherPdfRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idVoucher = requestParameters?.idVoucher;
        if (idVoucher === null || idVoucher === undefined) {
            throw new Error('Required parameter idVoucher was null or undefined when calling downloadMioVoucherPdf.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/voucher/${this.configuration.encodeParam({name: "idVoucher", value: idVoucher, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pdf`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<string>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elenco paginato degli esercenti abilitati per un proprio voucher (owner-check; 404 se non del caller, flag spento, voucher non spendibile o scaduto)
     * @endpoint get /api/v1/cittadino/voucher/{idVoucher}/esercenti
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public elencoEsercentiMioVoucher(requestParameters: ElencoEsercentiMioVoucherRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelVoucherEsercenteDTO>;
    public elencoEsercentiMioVoucher(requestParameters: ElencoEsercentiMioVoucherRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelVoucherEsercenteDTO>>;
    public elencoEsercentiMioVoucher(requestParameters: ElencoEsercentiMioVoucherRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelVoucherEsercenteDTO>>;
    public elencoEsercentiMioVoucher(requestParameters: ElencoEsercentiMioVoucherRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idVoucher = requestParameters?.idVoucher;
        if (idVoucher === null || idVoucher === undefined) {
            throw new Error('Required parameter idVoucher was null or undefined when calling elencoEsercentiMioVoucher.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling elencoEsercentiMioVoucher.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/voucher/${this.configuration.encodeParam({name: "idVoucher", value: idVoucher, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/esercenti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelVoucherEsercenteDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata dei voucher del cittadino (self-scoped; include gli scaduti col flag)
     * @endpoint get /api/v1/cittadino/voucher
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listaMieiVoucher(requestParameters: ListaMieiVoucherRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelVoucherCittadinoDTO>;
    public listaMieiVoucher(requestParameters: ListaMieiVoucherRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelVoucherCittadinoDTO>>;
    public listaMieiVoucher(requestParameters: ListaMieiVoucherRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelVoucherCittadinoDTO>>;
    public listaMieiVoucher(requestParameters: ListaMieiVoucherRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listaMieiVoucher.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listaMieiVoucher.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/voucher`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelVoucherCittadinoDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
